/* =========================================================
   Barra "Compre mais, economize mais" — atualização em tempo real
   Lê a quantidade de itens do carrinho e atualiza a barra sem
   precisar fechar e abrir a gaveta.
   ========================================================= */

(function () {
  var lastCount = null;
  var timer = null;

  function bars() {
    return document.querySelectorAll('[data-sr-tiers]');
  }

  function render(count) {
    bars().forEach(function (bar) {
      var qtys = (bar.dataset.qtys || '').split(',').map(Number).filter(Boolean);
      var labels = (bar.dataset.labels || '').split(',').map(Number).filter(Boolean);
      if (!qtys.length) return;

      bar.dataset.count = count;

      var nextIndex = -1;
      for (var i = 0; i < qtys.length; i++) {
        if (count < qtys[i]) {
          nextIndex = i;
          break;
        }
      }

      /* mensagem */
      var msg = bar.querySelector('[data-sr-msg]');
      if (msg) {
        if (nextIndex === -1) {
          msg.innerHTML = '<strong>Você liberou ' + labels[labels.length - 1] + '% OFF!</strong>';
        } else {
          var missing = qtys[nextIndex] - count;
          msg.innerHTML =
            'Leve mais ' + missing + ' peça' + (missing > 1 ? 's' : '') +
            ' e ganhe <strong>' + labels[nextIndex] + '% OFF</strong>';
        }
      }

      /* bolinhas */
      var items = bar.querySelectorAll('.sr-tiers__item');
      items.forEach(function (item, index) {
        var qty = Number(item.dataset.qty);
        item.classList.toggle('is-reached', count >= qty);
        item.classList.toggle('is-next', index === nextIndex);
      });

      /* barra de progresso: avança de bolinha em bolinha */
      var first = qtys[0];
      var last = qtys[qtys.length - 1];
      var span = last - first;
      var pct = span > 0 ? ((count - first) / span) * 100 : count >= first ? 100 : 0;
      if (pct < 0) pct = 0;
      if (pct > 100) pct = 100;

      var fill = bar.querySelector('[data-sr-fill]');
      if (fill) fill.style.width = pct + '%';
    });
  }

  function refresh(force) {
    if (!bars().length) return;

    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!force && cart.item_count === lastCount) return;
          lastCount = cart.item_count;
          render(cart.item_count);
        })
        .catch(function () {});
    }, 60);
  }

  /* 1. Primeira renderização, com o valor já vindo do servidor */
  function init() {
    var bar = document.querySelector('[data-sr-tiers]');
    if (bar) render(Number(bar.dataset.count || 0));
  }

  document.addEventListener('DOMContentLoaded', init);
  init();

  /* 2. Sempre que o tema falar com o carrinho */
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var path = typeof url === 'string' ? url : (url && url.url) || '';

    return nativeFetch.apply(this, arguments).then(function (response) {
      if (/\/cart(\/|\.js|$)/.test(path) && !/\/cart\.js/.test(path)) refresh();
      return response;
    });
  };

  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      if (/\/cart(\/|$)/.test(this.responseURL || '')) refresh();
    });
    return nativeSend.apply(this, arguments);
  };

  /* 3. Eventos do tema e mudanças na gaveta */
  ['cart:change', 'cart:updated', 'cart:refresh', 'variant:change'].forEach(function (evt) {
    document.addEventListener(evt, function () { refresh(true); });
  });

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function () { refresh(); }).observe(drawer, {
      childList: true,
      subtree: true,
    });
  }
})();